var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page"},[_c('TopPage',{attrs:{"scrollObserve":_vm.observScrollPage}}),_c('h1',[_vm._v("Observe")]),_c('button',{on:{"click":function($event){return _vm.clickSub()}}},[_vm._v("Click Sub")]),_c('BackToTop',{attrs:{"scrollObserv":_vm.observBottomPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }